import React from "react";
import "../App.css";
import { motion } from "framer-motion";
import sarepay from "../assets/imgTwo/sarepay-screen.svg";
import mozfin from "../assets/imgTwo/bank.svg";
import pos from "../assets/imgTwo/black-POS.svg";
import pensol from "../assets/imgTwo/pensolgroup.png";
import pay from "../assets/imgTwo/sarepay-history.svg";
import Arrow from "../assets/imgTwo/arrow.svg";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const slideInFromRight = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};
const slideInFromLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};


export const HeroSection = () => {
  return (
    <section
      id="about"
      className=" bg-[#F7F7F7] md:px-[5em] py-16 animate-slidein"
    >
      <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
        <div className="w-full md:w-1/2 p-4">
          <h1 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
            Accept Payments Seamlessly
          </h1>
          <p className="text-gray-800 text-lg">
            Businesses need fast, secure, and flexible payment solutions to improve customer experience and cash flow.
          </p>
          <p className="text-black mt-8 font-bold text-lg">
            What You Can Do:
          </p>
          <ul className="text-gray-800 list-none space-y-4 mt-4">
            <li>
              <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
              <span className="font-bold">Accept Payments Anytime, Anywhere:</span> Receive payments via cards, and transfers.
            </li>
            <li>
              <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
              <span className="font-bold">Virtual Accounts for Businesses:</span> Assign unique account numbers to customers for easy reconciliation.
            </li>
            <li>
              <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
              <span className="font-bold">Regulatory Compliance & Security: </span> Built with top-tier security and compliance with financial regulations.
            </li>
          </ul>
          <a href="https://sarepay.com/" className="text-inherit no-underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-[#07775D] flex items-center justify-center text-white my-6 rounded-full px-12 py-3 font-semibold transition-all duration-300 hover:bg-green-800 group">
              Learn more
              <span className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1">
                <img src={Arrow} alt="enter" />
              </span>
            </button>
          </a>
        </div>
        <motion.div
          className="w-full md:w-[35em] p-2 flex md:justify-end"
          variants={slideInFromRight}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <img src={sarepay} alt="Sarepay payment solution screen" className="rounded-lg" />
        </motion.div>
      </div>
    </section>
  );
};

const AboutSection = () => (
  <section
    id="home"
    className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container px-2 md:px-0 mx-auto flex flex-col justify-between md:flex-row items-center">
      <motion.div
        className="w-full md:w-1/2 p-4"
        variants={slideInFromLeft}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <img src={mozfin} alt="Mozfin digital banking solution screen" className="rounded-lg" />
      </motion.div>

      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
          Build Your Own Digital Bank
        </h2>
        <p className="text-gray-800 text-lg">
          Uniswitch’s Digital Banking as a Service provides businesses and financial institutions with the infrastructure to launch and manage digital banking services effortlessly.          </p>
        <p className="text-black mt-8 font-bold text-lg">
          What You Can Do:
        </p>
        <ul className="text-gray-800 list-none space-y-4 mt-4">
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Custom Banking Solutions: </span> Offer customers bank accounts, savings, and payment services under your brand.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Automated Reconciliation & Ledger Management:</span> Track transactions with real-time updates.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Checkout & Payment Links:</span> Offer seamless checkout experiences and share payment links for instant transactions.
          </li>
        </ul>

        <a href=" https://mozfin.com/" className="text-inherit no-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="bg-[#07775D] flex items-center justify-center text-white my-6 rounded-full px-12 py-3 font-semibold transition-all duration-300 hover:bg-green-800 group">
            Learn more
            <span className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1">
              <img src={Arrow} alt="enter" />
            </span>
          </button>
        </a>
      </div>
    </div>

  </section>
);

const PortfolioSection = () => (
  <section
    id="portfolio"
    className=" bg-[#F7F7F7] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
          Expand Financial Access
        </h2>
        <p className="text-gray-800 text-lg">
          Uniswitch’s Agency Banking Solution empowers financial institutions and businesses to reach more customers through an extensive agent network.

        </p>
        <p className="text-black mt-8 font-bold text-lg">
          What You Can Do:
        </p>
        <ul className="text-gray-800 list-none space-y-4 mt-4">
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Agent Onboarding & Management: </span> Recruit and manage a network of banking agents with ease.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Cash Deposits & Withdrawals: </span> Enable agents to process cash transactions on behalf of customers.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Bill Payments & Airtime Top-Up: </span>  Offer utility bill payments, airtime purchases, and more at agent locations.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Real-Time Transaction Tracking:  </span>  Monitor all agent transactions through a secure dashboard.
          </li>
        </ul>
        <button className="bg-[#07775D] flex items-center justify-center text-white my-6 rounded-full px-12 py-3 font-semibold transition-all duration-300 hover:bg-green-800 group">
          Learn more
          <span className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1">
            <img src={Arrow} alt="enter" />
          </span>
        </button>
      </div>

      <motion.div
        className="w-full md:w-[35em] p-2 flex md:justify-end"
        variants={slideInFromRight}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <img src={pos} alt="POS device for agency banking" className="rounded-lg" />
      </motion.div>

    </div>
  </section>
);

const ServicesSection = () => (
  <section
    id="services"
    className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container px-2 md:px-0 mx-auto flex flex-col justify-between md:flex-row items-center">

      <motion.div
        className="w-full md:w-1/2 p-4"
        variants={slideInFromLeft}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <img src={pay} alt="Sarepay transaction history screen" className="rounded-lg" />
      </motion.div>



      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
          Fast, Reliable Bulk Payments
        </h2>
        <p className="text-gray-800 text-lg">
          Uniswitch’s Disbursement Solution ensures seamless payouts.            </p>
        <p className="text-black mt-8 font-bold text-lg">
          What You Can Do:
        </p>
        <ul className="text-gray-800 list-none space-y-4 mt-4">
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Bulk Payments & Payroll Processing: </span> Send instant payments to multiple recipients with a single action.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Vendor & Supplier Payments: </span> Automate invoice settlements and supplier transactions.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Government & NGO Payouts: </span> Efficiently distribute funds for government schemes, grants, and social programs.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Real-Time Settlement & Reporting:  </span>Track disbursements with real-time dashboards and reports.
          </li>
        </ul>
        <a href="https://sarepay.com/" className="text-inherit no-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="bg-[#07775D] flex items-center justify-center text-white my-6 rounded-full px-12 py-3 font-semibold transition-all duration-300 hover:bg-green-800 group">
            Learn more
            <span className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1">
              <img src={Arrow} alt="enter" />
            </span>
          </button>
        </a>
      </div>
    </div>

  </section>
);

const PensionSection = () => (
  <section
    id="portfolio"
    className=" bg-[#F7F7F7] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
          Pension Remittance – Simplify <br></br>Retirement Contributions
        </h2>
        <p className="text-gray-800 text-lg">
          Uniswitch’s Pension Remittance product enables employers and payroll providers to remit
          pension contributions directly and quickly, securely, and in compliance with regulations.
        </p>
        <p className="text-black mt-8 font-bold text-lg">
          What You Can Do:
        </p>
        <ul className="text-gray-800 list-none space-y-4 mt-4">
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Bulk Pension Remittances: </span>  Upload schedules and process multiple pension contributions in one click.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Integration with Payroll Systems:</span>  Sync seamlessly with payroll platforms for automated remittance.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Regulatory Compliance: </span>  Stay aligned with pension regulations and ensure timely submissions.
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            <span className="font-bold">Real-Time Tracking & Reports: </span>  Monitor remittance status and generate reports.
          </li>
        </ul>
        <a href="https://payyourpensions.com/" className="text-inherit no-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="bg-[#07775D] flex items-center justify-center text-white my-6 rounded-full px-12 py-3 font-semibold transition-all duration-300 hover:bg-green-800 group">
            Learn more
            <span className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1">
              <img src={Arrow} alt="enter" />
            </span>
          </button>
        </a>
      </div>

      <motion.div
        className="w-full md:w-[35em] p-2 flex md:justify-end"
        variants={slideInFromRight}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <img src={pensol} alt="POS device for agency banking" className="rounded-lg" />
      </motion.div>

    </div>
  </section>
);


export const OurProducts = () => (
  <div className="font-san mx-auto bg-[#F7F7F7] pt-6">
    <Navbar />
    <HeroSection />
    <AboutSection />
    <PortfolioSection />
    <ServicesSection />
    <PensionSection />
    <Footer />
  </div>
);

export default OurProducts;
